import * as React from 'react';
import { Responsive, RoundButton, Tooltip } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as style from './style.css';

interface IFavoriteButtonColoredProps {
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
  isFavorite: boolean;
}

export const FavoriteButtonColored = React.forwardRef(
  ({ onClick, isFavorite }: IFavoriteButtonColoredProps, ref: React.RefObject<HTMLDivElement>) => {
    return (
      <div className={clsx(isFavorite && style['favorite-button--on'])} ref={ref}>
        <Responsive desktop>
          <Tooltip title={isFavorite ? 'В избранном' : 'Добавить в избранное'} placement="left">
            <RoundButton
              theme="fill_dark"
              size="M"
              title="Добавить в избранное"
              onClick={onClick}
              icon={isFavorite ? <IconToggleHeartOn16 /> : <IconToggleHeartOff16 />}
            />
          </Tooltip>
        </Responsive>
        <Responsive tablet phone>
          <RoundButton
            theme="fill_dark"
            size="M"
            title="Добавить в избранное"
            onClick={onClick}
            icon={isFavorite ? <IconToggleHeartOn16 /> : <IconToggleHeartOff16 />}
          />
        </Responsive>
      </div>
    );
  },
);

FavoriteButtonColored.displayName = 'FavoriteButtonColored';
